module.exports = __webpack_public_path__ + "static/img/IMG_20151021_225626.a1189096.jpg";